import AgentForm from "./AgentForm.container";

export default AgentForm;
